import { DocumentFormProps } from "./ValidationModal";
import { Box, Stack, Button, Typography } from "@mui/material";

const titles: { [key: string]: string } = {
  resume: 'Vérification du CV',
  driver_license: 'Vérification du permis de conduire',
  medical_visit: 'Vérification de la visite médicale',
};

const SimpleValidationDocumentForm = ({ document, onApprove, onReject, disabled }: DocumentFormProps) => {
  const title = titles[document.key] ?? 'Vérification du document';

  return (
    <Box sx={{ height: '100%' }}>
      <Typography variant="h2" sx={{ textAlign: 'center', mb: 8, fontWeight: 'bold' }}>{title}</Typography>
      {!disabled && (
        <Stack direction="row" justifyContent="space-between" gap={2} mt={4}>
          <Button variant="outlined" color="error" onClick={onReject}>Refuser le document</Button>
          <Button variant="contained" color="primary" onClick={() => onApprove({})}>Valider</Button>
        </Stack>
      )}
    </Box>
  );
};

export default SimpleValidationDocumentForm;
